import { CodeNote, NoteType } from '../../types/code.types';

interface CodingGuidelinesProps {
  notes: CodeNote[];
}

const NOTE_TYPE_LABELS: Record<NoteType, string> = {
  CodeFirst: 'Code First',
  UseAdditionalCode: 'Use Additional Code',
  Excludes1: 'Excludes1',
  Excludes2: 'Excludes2',
  Includes: 'Includes',
  InclusionTerm: 'Inclusion Terms',
  CodeAlso: 'Code Also',
};

const CodingGuidelines = ({ notes }: CodingGuidelinesProps) => {
  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h2 className="text-2xl font-bold mb-4">📋 Official Coding Guidelines</h2>
      {notes.length === 0 ? (
        <p className="text-gray-600 text-center py-8">No official coding notes for this code</p>
      ) : (
        <div className="space-y-6">
          {notes.map((group, groupIndex) => (
            <div key={groupIndex}>
              <h3 className="text-lg font-bold text-primary-700 mb-3">{NOTE_TYPE_LABELS[group.noteType]}</h3>
              <div className="space-y-2">
                {group.items.map((item, itemIndex) => (
                  <div key={itemIndex} className="p-3 bg-gray-50 rounded-lg">
                    <p className="text-gray-800">
                      {item.text}
                      {item.referencedCode && <span className="text-gray-500"> ({item.referencedCode})</span>}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CodingGuidelines;
